class GatedForm extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.setupListeners()
  }

  setupListeners() {
    this.postId = this.getPostIdFromURL()
    this.form = this.querySelector('form')
    this.form.addEventListener('submit', this.handleSubmit.bind(this))

    this.closeButton = this.querySelector('.close-button')
    this.closeButton.addEventListener('click', this.handleClose.bind(this))

    this.openButtons = document.querySelectorAll('[href="#open-gated-popup"]')
    this.openButtons.forEach(button => {
      button.addEventListener('click', this.handleOpen.bind(this))
    })

    this.openPostButton = this.querySelector('[href="#open-gated-post"]')
    if (this.openPostButton) {
      this.openPostButton.addEventListener('click', this.handleOpenPost.bind(this))
    }
  }

  handleClose() {
    this.classList.add('opacity-0')
    this.classList.add('pointer-events-none')

    this.popupContent = this.querySelector('.gated-form-content')
    this.popupContent.classList.add('opacity-0')
    this.popupContent.classList.add('pointer-events-none')
  }

  handleOpen(e) {
    e.preventDefault()
    this.classList.remove('opacity-0')
    this.classList.remove('pointer-events-none')

    this.popupContent = this.querySelector('.gated-form-content')
    this.popupContent.classList.remove('opacity-0')
    this.popupContent.classList.remove('pointer-events-none')
  }

  handleSubmit(e) {
    e.preventDefault()

    // Disable submit button to prevent multiple submissions
    const submitButton = this.form.querySelector('button[type="submit"]')
    const originalText = submitButton.textContent
    submitButton.disabled = true
    submitButton.textContent = 'Submitting...'

    const formData = new FormData(this.form)
    const data = Object.fromEntries(formData)

    fetch('/wp-json/hubspot/v1/gated-form', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(result => {
        console.log('Success:', result)

        // Set access cookie for this taxonomy term
        const taxonomyTermId = this.form.querySelector('input[name="taxonomy_term_id"]').value
        this.setCookie(`wp-gated-access-${taxonomyTermId}`, 'true', 30) // 30 days

        // Verify cookie was set correctly
        setTimeout(() => {
          const testCookie = this.getCookie(`wp-gated-access-${taxonomyTermId}`)
          console.log('Cookie verification after setting:', testCookie)
          if (!testCookie) {
            console.error('Cookie was not set properly!')
          }
        }, 100)

        this.showThankYou()
        // Hide the form after successful submission
        this.form.style.display = 'none'

        // Always reload the page after successful submission
        setTimeout(() => {
          window.location.reload()
        }, 2000) // Wait 2 seconds to show thank you message
      })
      .catch(error => {
        console.error('Error:', error)
        // Show error message to user
        this.showError('Something went wrong. Please try again.')
      })
      .finally(() => {
        // Re-enable submit button
        submitButton.disabled = false
        submitButton.textContent = originalText
      })
  }

  showThankYou() {
    this.thankYou = this.querySelector('#gated-form-success')
    this.thankYou.classList.remove('opacity-0')
    this.thankYou.classList.remove('pointer-events-none')
  }

  showError(message) {
    // Look for existing error element or create one
    let errorElement = this.querySelector('.gated-form-error')
    if (!errorElement) {
      errorElement = document.createElement('div')
      errorElement.className =
        'gated-form-error text-red-600 mb-4 p-3 bg-red-50 border border-red-200 rounded'
      this.form.insertBefore(errorElement, this.form.firstChild)
    }
    errorElement.textContent = message
    errorElement.style.display = 'block'

    // Hide error after 5 seconds
    setTimeout(() => {
      errorElement.style.display = 'none'
    }, 5000)
  }

  setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + date.toUTCString()

    // For Pantheon wp- cookies, use simplified settings
    // Pantheon handles domain/security automatically for wp- pattern cookies
    const secure = window.location.protocol === 'https:' ? ';secure' : ''
    const sameSite = ';samesite=lax'

    document.cookie = `${name}=${value};${expires};path=/${secure}${sameSite}`

    // Debug: Log what cookie is being set
    console.log('Setting cookie:', `${name}=${value};${expires};path=/${secure}${sameSite}`)
  }

  getCookie(name) {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  getPostIdFromURL() {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('post_id')
  }

  handleOpenPost(e) {
    e.preventDefault()
    this.classList.remove('opacity-0')
    this.classList.remove('pointer-events-none')

    this.popupContent = this.querySelector('.gated-form-content')
    this.popupContent.classList.remove('opacity-0')
    this.popupContent.classList.remove('pointer-events-none')
    // Reload the page to show the gated content
    window.location.reload()
  }
}

if (!customElements.get('gated-form')) {
  customElements.define('gated-form', GatedForm)
}
